import { getActiveBrandId } from "@eweadn-qiankun/shared-utils";
import { getCrossBrandBootstrapCache } from "../store/bootstrapStore";
import type { CrossBrandBootstrapDto } from "../types";
import { resolveCrossBrandPromptItems } from "./resolvePromptItems";

function isDefaultBrandHub(bootstrap: CrossBrandBootstrapDto): boolean {
  const active = getActiveBrandId().trim().toLowerCase();
  const defaultBrand = (bootstrap.config.defaultBrandCode || "eweadn")
    .trim()
    .toLowerCase();
  return active === defaultBrand;
}

/** 默认品牌 Hub + 后台开启异品牌提示：WebHID 授权列表包含其它品牌 VID/PID */
export function shouldExpandHidPickerToAllBrands(): boolean {
  const bootstrap = getCrossBrandBootstrapCache();
  if (!bootstrap?.config.crossBrandPromptEnabled) return false;
  return isDefaultBrandHub(bootstrap);
}

export type HidVidPidRow = {
  vendorId: number;
  productId: number;
  productName?: string;
};

/** 已授权/刚选中的 HID 是否应走异品牌引导（不建链） */
export function shouldTreatHidsAsCrossBrand(
  hids: HidVidPidRow[],
  bootstrap = getCrossBrandBootstrapCache()
): boolean {
  if (!bootstrap?.config.crossBrandPromptEnabled) return false;
  if (!isDefaultBrandHub(bootstrap)) return false;
  if (!hids.length) return false;
  return resolveCrossBrandPromptItems(bootstrap, hids).length > 0;
}
